import { setCurrentView } from 'core/utils';
import React from 'react';
import { observer } from 'mobx-react';
import { ScheduledJobLogListTemplate } from 'themes/modules/alerts/pages';
import { ScheduledJobLogListViewStore } from '../stores';


@setCurrentView(rootStore => new ScheduledJobLogListViewStore(rootStore), 'scheduledJobLogListViewStore')
@observer
class ScheduledJobLogList extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
			// Wire up AlertsViewStore to ScheduledJobLogListViewStore for job log refresh triggers
			const { viewStore, scheduledJobLogListViewStore } = this.props;
			if (viewStore && viewStore.setScheduledJobLogListViewStore) {
				viewStore.setScheduledJobLogListViewStore(scheduledJobLogListViewStore);
			}
			return (
				<ScheduledJobLogListTemplate
					{...this.props}
					headerCell={[]}
					actions={scheduledJobLogListViewStore}
					viewStore={scheduledJobLogListViewStore}
				/>
			);
	}
}

export default ScheduledJobLogList;
